import mapButtonProps from './mapButtonProps';

export default function listWithPaginationAndCTAMapper(componentsData) {
  const { bannerProps, ...rest } = componentsData;

  return {
    ...rest,
    bannerProps: mapButtonProps(mapButtonProps(bannerProps, 'buttonProps'), 'secondaryButtonProps'),
  };
}
